<template>
  <div>
    <ShipmentPlan :disabled="disabled" />
  </div>
</template>

<script>
import ShipmentPlan from './shipment-plan-table/index.vue'

export default {
  name: 'order-shipmentPlan',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShipmentPlan,
  },
}
</script>
